module.exports = __webpack_public_path__ + "static/fonts/iconfont.98f8052.woff2";